import { authClient } from "@/lib/auth-client";
import { Navigate, Outlet } from "react-router";
import { Loader } from "lucide-react";

import licitigo_logo from "../../assets/licitigo_logo.svg";

export default function AuthGuard() {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="h-screen w-full flex flex-col gap-6 items-center justify-center">
        <img src={licitigo_logo} alt="Licitigo" className="h-14 w-auto" />
        <Loader className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/auth/login" />;
  }

  return <Outlet />;
}
